<template>
  <div>
    <div class="columns is-gapless is-border-top" :class="idx > 0 ? 'has-bg-white' : 'has-bg-light'">
      <div
        class="column columns is-gapless is-multiline is-padding-left-small is-padding-right-small is-padding-top is-padding-bottom">
        <div class="column is-5 is-padding-xxsmall">
          <div class="title is-5 has-text-weight-medium is-margin-bottom-small">
            <span class="is-uppercase">{{currentNotaire.label}}<span v-if="idx > 1"> {{idx}}</span></span>
          </div>
        </div>
        <div class="column is-7 is-padding-xxsmall">
          <div v-if="currentNotaire.name" class="title is-5 has-text-weight-medium is-margin-bottom-small">
            <span class="is-uppercase">{{currentNotaire.name}}</span>
          </div>
          <div>
            <span v-if="notaireEmpty"
                  class="is-size-6 is-uppercase">Aucune information renseignée</span>
          </div>
          <div class="title is-5">
            <div class="is-uppercase" v-if="currentNotaire && currentNotaire.address">
              <span
                v-if="currentNotaire.address && currentNotaire.address.line1">{{currentNotaire.address.line1}}</span>
              <!-- <br v-if="currentNotaire.address.line1"> -->
              <span v-if="currentNotaire.address && currentNotaire.address.zip_code || currentNotaire.address.city">{{currentNotaire.address.zip_code}} {{currentNotaire.address.city}}</span>
              <!-- <br v-if="currentNotaire.address.zip_code || currentNotaire.address.city"> -->
              <span
                v-if="currentNotaire.address && currentNotaire.address.country">{{currentNotaire.address.country}}</span>
            </div>
            <div class="is-margin-top-xxsmall">
              <span v-if="currentNotaire.phone">
                <span class="icon is-small is-margin-right-xxsmall"><i class="fal fa-phone-office"></i></span>
                <span class="is-margin-right-small">{{currentNotaire.phone}}</span>
              </span>
              <span v-if="currentNotaire.email">
                <span class="icon is-smal"><i class="fal fa-at"></i></span>
                <span class="is-uppercase">{{currentNotaire.email}}</span>
              </span>
            </div>
          </div>

        </div>
      </div>
      <div class="actionsOnRow actionsOnRow--vertical">
        <div v-if="!edit" class="">
          <button @click="openModalNotaire()" class="tooltip is-tooltip-left" data-tooltip="Modifier le notaire">
            <span class="icon"><i class="fal fa-marker"></i></span>
          </button>
        </div>
        <div v-if="idx > 0 && !edit" class="">
          <button @click="removeNotaire"
                  class="tooltip is-tooltip-left actionsOnRow-btn--hoverIsDanger"
                  data-tooltip="Supprimer le notaire">
            <span class="icon"><i class="fal fa-trash-alt"></i></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { AdvMx } from '@/mixins'
  import { cloneDeep } from 'lodash'
  import { mapState } from 'vuex'

  export default {
    name: 'NotaireItem',
    mixins: [AdvMx],
    data () {
      return {
        edit: false,
        currentNotaire: null,
        savedNotaire: null,
        pendingInput: false,
        selectedRow: 'notaire-'
      }
    },
    props: {
      sourceNotaire: {
        type: Object,
        required: true
      },
      idx: {
        type: Number,
        required: true
      }
    },
    computed: {
      ...mapState(['modal']),
      notaireEmpty () {
        return (this.currentNotaire.name === null || this.currentNotaire.name === '') &&
          (this.currentNotaire.address.line1 === null || this.currentNotaire.address.line1 === '') &&
          (this.currentNotaire.address.zip_code === null || this.currentNotaire.address.zip_code === '') &&
          (this.currentNotaire.address.city === null || this.currentNotaire.address.city === '') &&
          (this.currentNotaire.address.country === null || this.currentNotaire.address.country === '') &&
          (this.currentNotaire.phone === null || this.currentNotaire.phone === '') &&
          (this.currentNotaire.email === null || this.currentNotaire.email === '')
      }
    },
    watch: {
      sourceNotaire () {
        return this.init()
      },
      modal ({ mode, params, results }) {
        if (results) {
          if (mode === 'NOTAIRE_CONTACT' && params.idx === this.selectedRow) {
            this.editNotaire(results)
          }
        }
      }
    },
    methods: {
      editNotaire (val) {
        this.currentNotaire = val
        this.saveEditNotaire(this.currentNotaire)
      },
      saveEditNotaire (val) {
        this.$emit('editNotaire', { idx: this.idx, notaire: this.currentNotaire })
        this.edit = false
      },
      cancelEdit () {
        this.currentNotaire = cloneDeep(this.savedNotaire)
        this.edit = false
        this.pendingInput = false
      },
      removeNotaire () {
        this.$emit('removeNotaire', this.idx)
      },
      toggleSelectedRow (val) {
        this.selectedRow = val
        this.cancelEdit()
      },
      init () {
        this.currentNotaire = this.sourceNotaire
        this.savedNotaire = cloneDeep(this.sourceNotaire)
        this.pendingInput = false
        if (this.currentNotaire.address === null) {
          let address = {
            city: null,
            country: null,
            line1: null,
            line2: null,
            region: null,
            state: null,
            zip_code: null
          }
          this.currentNotaire.address = Object.assign({}, address)
        }
      },
      openModalNotaire () {
        let params = {
          title: this.currentNotaire.label,
          source: { ...this.currentNotaire },
          idx: this.selectedRow
        }
        this.$store.commit('setModal', { mode: 'NOTAIRE_CONTACT', params })
      }
    },
    created () {
      this.selectedRow = this.selectedRow + this.idx
      this.init()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/adv/FeuilleDeRoute/NotaireItem.vue